import { tns } from 'tiny-slider/src/tiny-slider';
import { parseHTML } from '../helpers';

const controls = parseHTML(
    `<div>
        <button class="c-prev" aria-label="c-prev"></button>
        <button class="c-next" aria-label="c-next"></button>
    </div>`
);

const programmeSliders = document.querySelectorAll('.programmes-slider');

function init() {
    if (programmeSliders.length) {
        programmeSliders.forEach((slider) => {
            const track = slider.querySelector('.programmes-slider__track');
            const nav = slider.querySelector('.pnav');
            const navTrack = slider.querySelector('.pnav__track');

            nav.appendChild(controls);

            const primarySlider = tns({
                container: track,
                mode: 'gallery',
                speed: 800,
                // autoHeight: true,
                autoplay: true,
                autoplayTimeout: 8000,
                autoplayButtonOutput: false,
                controls: false,
                nav: true,
                navContainer: navTrack,
            });

            const programmeControls = tns({
                nav: false,
                speed: 800,
                autoplay: false,
                loop: false,
                rewind: true,
                controls: true,
                controlsContainer: controls,
                items: 2,
                slideBy: 1,
                container: navTrack,
                edgePadding: 20,
                gutter: 10,

                responsive: {
                    576: {
                        items: 3,
                        edgePadding: 20,
                    },

                    992: {
                        items: 4,
                    },
                }
            });

            primarySlider.events.on('indexChanged', ({ index }) => {
                programmeControls.goTo(index == 6 || index <= 1  ? 'first' : index)
            })

        });
    }
}

export default {
    init,
};
